import React, { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Paper from "@mui/material/Paper";
import Draggable from "react-draggable";
import "./ScreenShot.css";
import configData from "../../config.json";
import { useNavigate } from "react-router-dom";
import { getToken } from "../../utils/auth"

//dialog func - dragable
function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

function ScreenShot({ device_id, multi, handleNewToken }) {
  const navigate = useNavigate();
  //dialog
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  //screen shot
  const [screenshot, setScreenshot] = useState([]);
  const updateScreenShot = (device_id) => {
    const token = getToken()

    const headers = {
      "Content-Type": "application/json",
      "x-access-token": token,
    };
    fetch(`${configData.SERVER_URL}/Trigger-Screen-Shot/${device_id}`, {
      headers,
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .then((data) => {
        if (
          data.url ===
          "Failed to upload the Image file to the server, HTTP 500 Internal Server Error"
        ) {
          console.log(data.url);
        } else {
          if (data.url === "request failed error") {
            let newErrorText = String(data.url) + " " + String(data.ts);
            console.log(newErrorText);
          } else {
            console.log("Success");
            setScreenshot(data);
          }
        }
      })
      .catch((error) => {
        if (error.message === "401" || error.message === "403") {
          if (multi === true) {
            handleNewToken(false);
          } else {
            navigate("/");
          }
        } else {
          console.log(error);
        }
      });
  };
  return (
    <div>
      <Button onClick={handleClickOpen}>
        {screenshot.length === 0 ? "not found" : "screenshot "}
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          Screenshots
        </DialogTitle>
        <DialogContent>
          <div className="rtscroll-bg">
            {screenshot && (
              <div className="rtscroll-div">
                {screenshot.map((item) => (
                  <div className="rtimage-div" key={item.ts}>
                    <img src={item.url} alt="/" className="rtscroll-object" />
                    <span className="rtspn">
                      {new Date(item.ts).toLocaleString()}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Exit</Button>
        </DialogActions>
      </Dialog>
      <button
        type="button"
        className="btn btn-primary"
        onClick={() => updateScreenShot(device_id)}
      >
        ⟲
      </button>
    </div>
  );
}
ScreenShot.defaultProps = {
  multi: false,
  handleNewToken: false,
};
export default ScreenShot;
